import { z } from "zod";
import { dateFns, dateTimeFns, durationFns, instantFns, monthDayFns, timeFns, yearMonthFns, zonedDateTimeFns } from "iso-fns";
export * from "zod";
//#region src/iso-z.ts
const isoZRegistry = z.registry();
const instant = (_params) => {
	const schema = z.custom((val) => instantFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "Instant" });
	return schema;
};
const dateTime = (_params) => {
	const schema = z.custom((val) => dateTimeFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "DateTime" });
	return schema;
};
const zonedDateTime = (_params) => {
	const schema = z.custom((val) => zonedDateTimeFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "ZonedDateTime" });
	return schema;
};
const date = (_params) => {
	const schema = z.custom((val) => dateFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "Date" });
	return schema;
};
const time = (_params) => {
	const schema = z.custom((val) => timeFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "Time" });
	return schema;
};
const yearMonth = (_params) => {
	const schema = z.custom((val) => yearMonthFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "YearMonth" });
	return schema;
};
const monthDay = (_params) => {
	const schema = z.custom((val) => monthDayFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "MonthDay" });
	return schema;
};
const duration = (_params) => {
	const schema = z.custom((val) => durationFns.isValid(val), _params);
	isoZRegistry.add(schema, { isoTypeName: "Duration" });
	return schema;
};
const isoZ = {
	instant,
	dateTime,
	zonedDateTime,
	date,
	time,
	yearMonth,
	monthDay,
	duration,
	isoZRegistry
};
//#endregion
//#region src/index.ts
z.config({ customError: (iss) => {
	if (iss.code === "too_small" && iss.origin === "array") {
		const minimum = iss.minimum ?? 1;
		return { message: `Should have at least ${minimum} item${minimum === 1 ? "" : "s"}` };
	}
	if (iss.code === "too_small" && iss.origin === "string" && iss.minimum === 1) return { message: `Required` };
	if (iss.code === "too_small" && iss.origin === "string") return { message: `Must be at least ${iss.minimum} characters` };
	if (iss.code === "too_big" && iss.origin === "string") return { message: `Must be less than ${iss.maximum} characters` };
	if (iss.code === "too_small" && iss.origin === "number") return { message: iss.inclusive ? `Number must be greater than or equal to ${iss.minimum}` : `Number must be greater than ${iss.minimum}` };
	if (iss.code === "too_big" && iss.origin === "number") return { message: iss.inclusive ? `Number must be less than or equal to ${iss.maximum}` : `Number must be less than ${iss.maximum}` };
	if (iss.code === "invalid_type" && iss.input === null) return { message: "Required" };
	if (iss.code === "invalid_value" && iss.input === null) return { message: "Required" };
	return iss.message ? { message: iss.message } : void 0;
} });
function getEnumLabels(schema) {
	return schema.meta()?.enumLabels || schema.enum;
}
function setEnumLabels(schema, labels) {
	return schema.meta({ enumLabels: labels });
}
//#endregion
export { getEnumLabels, isoZ, setEnumLabels };
